import "./index.css";

const ScaffoldComponent: React.FC<{ children?: any }> = ({ children }) => {
  return <div className="scaffoldRoot">{children}</div>;
};
export default ScaffoldComponent;
